// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/envelope.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/envelope'

import { Icon, type IconComponentProps } from '../icon'

export const EnvelopeIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
